import request from "@/utils/axios";

//  分组-查询用户下全部分组
export function QUERYUSERGROUP(data) {
    return request({
        url: '/api/group//queryUserGroup',
        method: 'get',
        data
    })
}

//  分组-创建分组
export function CREATEGROUP(data) {
    return request({
        url: '/api/group/createGroup',
        method: 'post',
        data
    })
}

//  分组-删除分组
export function DELGROUP(data) {
    return request({
        url: '/api/group/delGroup',
        method: 'post',
        data
    })
}

//  分组-修改分组名称
export function UPDATEGROUP(data) {
    return request({
        url: '/api/group/updateGroup',
        method: 'post',
        data
    })
}

//  分组-人员信息
export function QUERYGROUPDETAILLIST(data) {
    return request({
        url: '/api/group/queryGroupDetailList',
        method: 'post',
        data
    })
}

//  分组-获取(行业/类别)下拉列表数据
export function QUERYALLBIGSMALLINDUSTRY(data) {
    return request({
        url: '/api/industrybrand/queryAllBigSmallIndustry',
        method: 'get',
        data
    })
}
//  分组-加入关注（批量/单个）
export function JOINGROUP(data) {
    return request({
        url: '/api/group/joinGroup',
        method: 'post',
        data
    })
}
// 分组-移出分组（批量/单个
export function REMOVEGROUPDETAIL(data) {
    return request({
        url: '/api/group/removeGroupDetail',
        method: 'post',
        data
    })
}
// 分组-移出分组（批量/单个
export function REMOVEGROUPONEDETAIL(data) {
    return request({
        url: '/api/group/removeGroupOneDetail',
        method: 'post',
        data
    }) 
}

// 联盟客详情-上半部分+商品图片
export function ALLIANCEDETAILPART1(data) {
    return request({
        url: '/api/allianceguest/allianceDetailPart1',
        method: 'post',
        data
    })
}
// 联盟客详情-下半部分（youtube部分)
export function ALLIANCEDETAILPART2(data) {
    return request({
        url: '/api/allianceguest/allianceDetailPartNew',
        method: 'post',
        data
    })
}





//  洞察情报-查询联盟客筛选条件
export function QUERYSELECTLIST(data) {
    return request({
        url: '/api/allianceguest/querySelectList',
        method: 'get',
        data
    })
}

// 查询联盟客分组
export function QUERYHASGROUP(data) {
    return request({
      url: '/api/allianceguest/queryHasGroup',
      method: 'POST',
      data
    })
  }